// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.donut-analytics-card {
  padding: 16px !important;
}

.donut-chart-container {
  width: 150px;
  height: 150px;
}

.donut-legend-container {
  height: 120px;
  display: flex;
  align-items: center;
}

.legend-gray-box {
  width: 100%;
  height: 110px;
  background-color: #f1f5f9;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px;
  box-sizing: border-box;
  transition: all 0.25s ease;
}

/* Active panel layout */
.status-indicator-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  box-shadow: 0 0 3px rgba(0,0,0,0.1);
}

.info-title {
  font-size: 11px;
  font-weight: 800;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value h3 {
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
  margin: 2px 0 0 0;
  font-family: "Outfit", "Inter", sans-serif;
  letter-spacing: -0.5px;
}

.info-subtitle {
  font-size: 9px;
  color: #64748b;
  margin: 1px 0 0 0;
  font-weight: 600;
}

/* Default panel layout */
.info-title-default {
  font-size: 11px;
  font-weight: 800;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
}

.info-value-default {
  font-size: 22px;
  font-weight: 800;
  color: #2f3299;
  margin: 3px 0;
  font-family: "Outfit", "Inter", sans-serif;
  letter-spacing: -0.5px;
}

.info-subtitle-default {
  font-size: 8.5px;
  color: #94a3b8;
  font-weight: 600;
  margin: 0;
}

/* Micro-animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.animate-fade-in {
  animation: fadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

`, "",{"version":3,"sources":["webpack://./src/components/dashboard/DonutAnalyticsCard.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,8DAA8D;AAChE","sourcesContent":[".donut-analytics-card {\n  padding: 16px !important;\n}\n\n.donut-chart-container {\n  width: 150px;\n  height: 150px;\n}\n\n.donut-legend-container {\n  height: 120px;\n  display: flex;\n  align-items: center;\n}\n\n.legend-gray-box {\n  width: 100%;\n  height: 110px;\n  background-color: #f1f5f9;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 12px;\n  box-sizing: border-box;\n  transition: all 0.25s ease;\n}\n\n/* Active panel layout */\n.status-indicator-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n  box-shadow: 0 0 3px rgba(0,0,0,0.1);\n}\n\n.info-title {\n  font-size: 11px;\n  font-weight: 800;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.info-value h3 {\n  font-size: 24px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 2px 0 0 0;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  letter-spacing: -0.5px;\n}\n\n.info-subtitle {\n  font-size: 9px;\n  color: #64748b;\n  margin: 1px 0 0 0;\n  font-weight: 600;\n}\n\n/* Default panel layout */\n.info-title-default {\n  font-size: 11px;\n  font-weight: 800;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0;\n}\n\n.info-value-default {\n  font-size: 22px;\n  font-weight: 800;\n  color: #2f3299;\n  margin: 3px 0;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  letter-spacing: -0.5px;\n}\n\n.info-subtitle-default {\n  font-size: 8.5px;\n  color: #94a3b8;\n  font-weight: 600;\n  margin: 0;\n}\n\n/* Micro-animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
